import { rdsEventStatus_Dto } from "../../../interfaces/dtos/rdsEvent";
import { rdsMeeting_Dto } from "../../../interfaces/dtos/rdsMeeting";
import { Track } from "../../../interfaces/dtos/track";
import { Win, WinCalculated } from "../../../interfaces/dtos/win";
import { WinState } from "../../../redux/win/winSlice";
import { CommonCanUpdate, CommonCanUpdateDesc } from "../../../utils/commonRules";
import { eventProgressCodes, eventStatusCodes, eventStatusDesc } from "../../shared/commonConstants";
import { DisabledCriteria, getDisabledCriteria } from "../../shared/disabledCriteria";

const disabledStatuses = [eventStatusCodes.Void, eventStatusCodes.Abandon];

const commonDisabledCriteria = (
    meeting?: rdsMeeting_Dto, eventStatus?: rdsEventStatus_Dto, track?: Track
): DisabledCriteria[] => [
        {
            condition: !track,
            reason: "the track could not be loaded"
        },     
        {
            condition: disabledStatuses.includes(eventStatus?.status ?? ''),
            reason: `the event is ${eventStatusDesc(eventStatus?.status ?? '').toLowerCase()}`
        },
        {
            condition: disabledStatuses.includes(meeting?.status ?? ''),
            reason: `the meeting is ${eventStatusDesc(meeting?.status ?? '').toLowerCase()}`
        },
        { condition: eventStatus?.progressCode === eventProgressCodes.Off, reason: "the event has been offed" }
    ];

export const getMarketStatusDisabledResult = (
    winState: WinState, currentEventWin?: Win, calc?: WinCalculated, track?: Track,
    meeting?: rdsMeeting_Dto, eventStatus?: rdsEventStatus_Dto
) => getDisabledCriteria([
    { condition: winState.saving },   
    {
        condition: (currentEventWin?.country === 'UK' || currentEventWin?.country === 'IE') && currentEventWin?.categoryCode === 'HR',
        reason: "you can't change for UK or Irish horses"
    },
    {
        condition: (calc?.isSuspended && currentEventWin?.bettingState === 'early') ?? false,
        reason: "you can't change early prices if suspended"
    },
    {
        condition: track && calc ? calc.isEarlyPrice && !track.isTrackActive : false,
        reason: "the track is inactive"
    },
    {
        condition: track && calc ? calc.isEarlyPrice && !track.isBPDisplay : false,
        reason: "the track has BP Display as false"
    },
    {
        condition: calc !== undefined && calc.isBoardPrice && !CommonCanUpdate(currentEventWin?.provider, currentEventWin?.categoryCode),
        reason: `you can't update to EP for ${CommonCanUpdateDesc}`
    },       
    ...commonDisabledCriteria(meeting, eventStatus, track)
], true);

export const getSuspendedDisabledResult = (
    winState: WinState, calc?: WinCalculated,
    meeting?: rdsMeeting_Dto, eventStatus?: rdsEventStatus_Dto, track?: Track
) => getDisabledCriteria([
    { condition: winState.saving },
    {
        condition: !calc?.isEarlyPrice,
        reason: `you can only ${calc?.isSuspended ? 'unsuspend' : 'suspend'} early prices`
    },
    {
        condition: calc?.isSupplierSuspended ?? false,
        reason: `it was ${calc?.isSuspended ? 'suspended' : 'unsuspended'} by the supplier`
    },
    {
        condition: !calc?.isSuspended && !calc?.isBetmakerPrice,
        reason: "you can only suspend betmaker prices"
    },
    ...commonDisabledCriteria(meeting, eventStatus, track)
], true);